// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"ead9995342fdb1aaaede","132":"a4267b5f8143e16e6d82","133":"35df04095a8b6134771a","171":"822dad2461110e26cb7e"}[chunkId] + ".chunk.js";
};